import { LibraryItemType } from "@src/types.generated";

/** The operational landing tab modules carry in the strip. */
export const LIBRARY_ITEM_OVERVIEW_TAB = "overview";

/**
 * The types besides modules whose detail page is the redesigned one under
 * Ff.LibraryItemOverviewTab. Without the flag every type keeps the previous
 * page.
 */
export const hasRedesignedDetailPage = (
  type: LibraryItemType | null | undefined,
): boolean =>
  type === LibraryItemType.Course ||
  type === LibraryItemType.Skill ||
  type === LibraryItemType.TrainingResource ||
  type === LibraryItemType.Task ||
  type === LibraryItemType.Audit;

/**
 * Operations items — checklists and audits. Nobody is assigned one: locations
 * complete them on a schedule, and the result is a submission rather than an
 * assignment status, so their Overview and Reporting read differently.
 */
export const isOperationsType = (
  type: LibraryItemType | null | undefined,
): boolean => type === LibraryItemType.Task || type === LibraryItemType.Audit;

type Input = {
  /** The item was already live (not a draft) when the page opened. */
  wasLiveOnOpen: boolean;
  canEdit: boolean;
  /** The tab values the URL may name for this item, in strip order. */
  mainTabValues: string[];
};

/**
 * Where an item lands when its URL names no tab. Live content opens on its
 * operational Overview. A draft is still being made, so it opens in the
 * builder for anyone who can edit — a brand-new module lands straight in
 * edit mode — and on the read-only content for everyone else. An item with
 * no canvas at all (a file, a video, a link) has nothing to build or read,
 * so its draft opens on the Overview too, where it is published from.
 */
export const getDefaultMainTab = ({
  wasLiveOnOpen,
  canEdit,
  mainTabValues,
}: Input): string => {
  if (wasLiveOnOpen && mainTabValues.includes(LIBRARY_ITEM_OVERVIEW_TAB)) {
    return LIBRARY_ITEM_OVERVIEW_TAB;
  }
  if (canEdit && mainTabValues.includes("build")) {
    return "build";
  }
  if (mainTabValues.includes("preview")) {
    return "preview";
  }
  if (mainTabValues.includes(LIBRARY_ITEM_OVERVIEW_TAB)) {
    return LIBRARY_ITEM_OVERVIEW_TAB;
  }
  return mainTabValues[0];
};
